import { PAGES } from "../types/pages"
import { lazy } from "react"
import { Navigate } from "react-router-dom"

const Advertising = lazy(() => import("../pages/Advertising"))
const SearchTermsTrends = lazy(() => import("../pages/SearchTermsTrends"))
const Projects = lazy(() => import("../pages/Projects"))
const ProjectData = lazy(() => import("../pages/ProjectData"))
const AddFilter = lazy(() => import("../layout/views/addfilter/AddFilter"))
const History = lazy(() => import("../pages/History"))
const CampaignsAutomation = lazy(() => import("../layout/views/advertising/campaigns/Campaigns"))
const ACOS = lazy(() => import("../layout/views/settings/acos/ACOS"))
const Other = lazy(() => import("../layout/views/settings/other/Other"))
const UnmanageCampaign = lazy(() => import("../layout/views/settings/unmanage/UnmanageCampaign"))
const CustomerContainer = lazy(() =>
  import("../modules/customers").then((module) => ({ default: module.CustomerContainer }))
)

const PagesRoutes = [
  {
    path: PAGES["Home"],
    component: <Navigate to={PAGES["Advertising"]} replace />,
    exact: true,
  },
  {
    path: PAGES["Advertising"],
    component: <Advertising />,
    exact: true,
  },
  {
    path: PAGES["Opportunities report"],
    component: <SearchTermsTrends />,
    exact: true,
  },
  {
    path: PAGES["Projects"],
    component: <Projects />,
    exact: true,
  },
  {
    path: PAGES["Project data"],
    component: <ProjectData />,
    exact: true,
  },
  {
    path: PAGES["Filter"],
    component: <AddFilter />,
  },
  {
    path: PAGES["History"],
    component: <History />,
    exact: true,
  },
  {
    path: PAGES["History (SP SKC)"],
    component: <Navigate to={`${PAGES["History"]}?tab=sp`} replace />,
    exact: true,
  },
  {
    path: PAGES["History (SP)"],
    component: <Navigate to={`${PAGES["History"]}?tab=sp`} replace />,
    exact: true,
  },
  {
    path: PAGES["Advertizing campaign"],
    component: <CampaignsAutomation />,
    exact: true,
  },
  {
    path: PAGES["ACOS Filter"],
    component: <ACOS />,
    exact: true,
  },
  {
    path: PAGES["Other Filter"],
    component: <Other />,
    exact: true,
  },
  {
    path: PAGES["Unmanage campaign"],
    component: <UnmanageCampaign />,
    exact: true,
  },
  {
    path: PAGES["History (SB/SD)"],
    component: <Navigate to={`${PAGES["History"]}?tab=sb`} replace />,
    exact: true,
  },
  {
    path: PAGES["Users"],
    component: <CustomerContainer />,
    exact: true,
  },
]
export default PagesRoutes
